import { styled } from '@mui/system';
import images from 'src/config/images';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { palette, shadows } from 'src/config/theme';

export const AuthContainer = styled(Container)({
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
});

export const AuthBg = styled('div')({
  // marginTop: 60,
  flex: 1,
  borderRadius: 16,
  background: `url(${images.auth.authBg})`,
  minHeight: 'calc(100vh - 120px)',
  height: 'calc(100vh - 120px)',
  backgroundSize: 'cover',
  '& > .MuiGrid-root': {
    height: '100%',
  },
  padding: 16,
});

export const Left = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  flexDirection: 'column',
  position: 'relative',
});

export const Right = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const AuthContent = styled('div')({
  borderRadius: '24px',
  border: '1px solid rgba(255, 255, 255, 0.05)',
  background: 'rgba(0, 0, 0, 0.15)',
  boxShadow: '0px 0px 45px 0px rgba(0, 0, 0, 0.10) inset',
  backdropFilter: 'blur(60px)',
  padding: '64px 50px',
  maxWidth: 340,
});

export const Logo = styled('img')({});
Logo.defaultProps = {
  src: images.logo,
};

export const Icon1 = styled('img')({
  position: 'absolute',
  bottom: '-10px',
  right: '00px',
});
Icon1.defaultProps = {
  src: images.auth.icon,
};

export const Icon2 = styled('img')({});
Icon2.defaultProps = {
  src: images.auth.login1,
};

export const SidebarOnOffContainer = styled(Box)(({ isPermanentOpen }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: '56px',
  left: isPermanentOpen ? '252px' : '60px',
  width: '56px',
  height: '56px',
  borderRadius: '40px',
  padding: '10px',
  backgroundColor: palette.primary.light3,
  zIndex: 10000,
  boxShadow: shadows[1],
  cursor: 'pointer',
  transition: 'left 0.3s ease-in-out',
}));